'use strict';

// TODO: if the notification format gets more complex, it may be better to accept the JSON tradeoff.
// i.e. send all job kwargs in notification as JSON,
// then replace all this logic with JSON.stringify and JSON.parse.
// downside is redis messages will be larger, and may have some redundant info.

const { get } = require('lodash');
const { payloadKeySeparator, payloadValueJoiner } = require('../enums/notifications');

// mappedJobType should be run_pricing_for_all if running run_pricing_for_all_parallel
// run_create_workpackage also has a _dag variant,
// but it must not be mapped to run_create_workpackage because we want to bypass bullqueue
const getMappedJobType = jobType => {
  if (jobType.startsWith('run_pricing_for_all')) {
    return 'run_pricing_for_all';
  }
  return jobType;
}

// handle case where payloadKey has array value. e.g. level_entry_keys for run_pricing_for_specific_pgs. Join array values with payloadValueJoiner.
const getSingleNotificationValue = ({ payloadKey, jobParams }) => {
  const value = get(jobParams, payloadKey);
  return Array.isArray(value) ? value.join(payloadValueJoiner) : value;
}

// if a payloadKey contains multiple keys, extract and join the relevant values to form the notification payload value.
// if a value is an array, join with payloadValueJoiner.
const getNotificationPayloadValue = ({ payloadKey, jobParams }) => {
  // some jobs may have no payloadKey / value. e.g. update_go_live_date
  if (payloadKey && payloadKey.includes(payloadKeySeparator)) {
    const payloadKeys = payloadKey.split(payloadKeySeparator);
    const payloadValues = payloadKeys.map(key => {
      return getSingleNotificationValue({ payloadKey: key, jobParams });
    });
    return payloadValues.join(payloadKeySeparator);
  }

  return getSingleNotificationValue({ payloadKey, jobParams });
}

module.exports = {
  getMappedJobType,
  getNotificationPayloadValue,
}